import {
  CustomerSigner,
  DocumentSignatureStatus,
  DocumentType,
} from '@bulthaup/api/db';
import { Button, Group, Stack } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconEye, IconTrash } from '@tabler/icons-react';

import { ConstructionSiteReportButton } from '../-construction-site-report-button';
import { SignatureRequestButton } from '../../-components/-signature-request-button';
import { SignatureRequestStatusBadge } from '../../-components/-signature-request-status-badge';
import { CancelSignatureRequestButton } from '../../-components/cancel-signature-request-button';
import { RouterOutput, trpc } from '../../../../../../services/trpc';
import { getUTDocumentUrl } from '../../../../../../services/upload';
import { ConstructionSiteReportList } from './construction-site-report-list';

export function ConstructionSiteReportSection({
  project,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
}) {
  const deleteUnsignedDocument =
    trpc.documents.deleteUnsignedDocument.useMutation();
  const CSRDocuments = project.documents.filter(
    document => document.type === DocumentType.CONSTRUCTION_SITE_REPORT,
  );
  const lastCSRDocument =
    CSRDocuments.length > 0
      ? CSRDocuments.sort(
          (a, b) => a.createdAt.getTime() - b.createdAt.getTime(),
        )[CSRDocuments.length - 1]
      : undefined;

  const signatureRecipient = {
    [CustomerSigner.CLIENT1]: `${project.customer.customer1Title} ${project.customer.customer1FirstName} ${project.customer.customer1LastName} - ${project.customer.customer1Email}`,
    [CustomerSigner.CLIENT2]: `${project.customer.customer2Title} ${project.customer.customer2FirstName} ${project.customer.customer2LastName} - ${project.customer.customer2Email}`,
  }[project.customer.signer];

  if (
    !lastCSRDocument ||
    !(
      [
        DocumentSignatureStatus.ONGOING,
        DocumentSignatureStatus.DRAFT,
      ] as DocumentSignatureStatus[]
    ).includes(lastCSRDocument.signatureStatus)
  ) {
    return (
      <Stack>
        <Group>
          <ConstructionSiteReportButton
            project={project}
            label={'Ajouter un PV'}
          />
        </Group>
        <ConstructionSiteReportList CSRDocuments={CSRDocuments} />
      </Stack>
    );
  }

  if (lastCSRDocument.signatureStatus === DocumentSignatureStatus.DRAFT) {
    return (
      <Stack>
        <Group>
          {/* <ConstructionSiteReportButton
            project={project}
            label={"Refaire le PV"}
            initialValues={{
              ...lastCSRDocument.CSReportMeta!,
              date: lastCSRDocument.CSReportMeta?.date
                ? new Date(
                    lastCSRDocument.CSReportMeta.date as unknown as string
                  )
                : undefined,
            }}
          /> */}
          <Button
            leftSection={<IconEye size={16} />}
            variant="outline"
            onClick={() => {
              window.open(
                getUTDocumentUrl(lastCSRDocument.utFileKey),
                '_blank',
              );
            }}
          >
            Voir le document
          </Button>
          {lastCSRDocument.signatureStatus ===
            DocumentSignatureStatus.DRAFT && (
            <Button
              variant="outline"
              leftSection={<IconTrash size={16} />}
              onClick={async () => {
                if (
                  confirm(
                    'Voulez-vous vraiment supprimer le PV de chantier ?\n\nCette action est irréversible.',
                  )
                ) {
                  await deleteUnsignedDocument.mutateAsync({
                    projectId: project.id,
                    documentType: DocumentType.CONSTRUCTION_SITE_REPORT,
                  });
                  notifications.show({
                    title: 'PV de chantier supprimé',
                    message: '',
                    color: 'green',
                  });
                }
              }}
            >
              Supprimer
            </Button>
          )}
        </Group>
        <Group>
          <SignatureRequestButton
            documentId={lastCSRDocument.id}
            recipient={signatureRecipient}
            label="Envoyer PV pour signature"
            signatureRequestName={`PV de chantier ${project.name}`}
          />
        </Group>
        <ConstructionSiteReportList CSRDocuments={CSRDocuments} />
      </Stack>
    );
  }

  if (lastCSRDocument.signatureStatus === DocumentSignatureStatus.ONGOING) {
    return (
      <Stack>
        <Group>
          <CancelSignatureRequestButton
            documentId={lastCSRDocument.id}
            label="Annuler la signature"
          />
          <Button
            leftSection={<IconEye size={16} />}
            variant="outline"
            onClick={() => {
              window.open(
                getUTDocumentUrl(lastCSRDocument.utFileKey),
                '_blank',
              );
            }}
          >
            Voir le document
          </Button>
        </Group>
        <Group>
          <SignatureRequestStatusBadge
            status={lastCSRDocument.signatureStatus}
          />
        </Group>
        <ConstructionSiteReportList CSRDocuments={CSRDocuments} />
      </Stack>
    );
  }
}
